export function calculateProgressMeasure( courseStatus ) {

    if ( courseStatus.completed > 0 || courseStatus.incomplete > 0) {
        const progressMeasure = Math.round( (courseStatus.passed / courseStatus.scoAmount) * 100 );
        return progressMeasure / 100;
    }

    return 0;
}
